import React, { Component } from 'react';
import Text from '@dbk/ui-text';
import { createContainer } from '@dbk-legacy/muster/react';
import Loading from '../../../components/common/loading/loading-circle';

class documentSigner extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pdfSubmitted: false,
      showLoadingForStatusUpdate: false,
    };
    this.messageReceive = this.messageReceive.bind(this);
    this.getParameterByName = this.getParameterByName.bind(this);
    this.showLoading = this.showLoading.bind(this);
  }

  messageReceive(ev) {
    if (ev.key == 'message') {

      const pathResult = ev.newValue;
      const docuSignEvent = this.getParameterByName("event", pathResult);

      if (pathResult == '') {
        return;
      }

      if (this.props.onPdfSubmit) {
        this.props.onPdfSubmit({
          status: docuSignEvent,
          pdfId: this.props.pdfId,
        });
      }
    }
  }

  showLoading(event) {
    const currentURL = event.target.contentWindow.location.href;
    const docuSignEvent = this.getParameterByName("event", currentURL);
    if (docuSignEvent) {
      this.setState({ showLoadingForStatusUpdate: true });
    }
  }

  getParameterByName(name, url) {
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
      results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  }

  render = () => {
    const { showLoadingForStatusUpdate } = this.state;

    localStorage.setItem('message', "");
    window.addEventListener("storage", this.messageReceive);

    const width = showLoadingForStatusUpdate ? "0" : "100%";
    const height = showLoadingForStatusUpdate ? "0" : "600";
    const { i18n: { messages } } = this.props;
    

    return (
      <div className="row">
        <div className="small-12">
          <iframe frameBorder="0" height={height} width={width} src={this.props.pdfUrl} onLoad={this.showLoading} />
          {this.state.showLoadingForStatusUpdate &&
            <div className="padding-top-50 padding-bottom-50">
              <Loading />
              <Text className="center-content" secondary> {messages['app.docusign.digisign.processinfo']}</Text>
            </div>
          }
        </div>
      </div >
    );
  }

}
export default createContainer({
  $queries: {
    i18n: {
      messages: true,
    },
  },
})(documentSigner);
